// extracted by mini-css-extract-plugin
export default {"headerBar":"MI-z","pointsSection":"NI-z","goToDashboard":"OI-z"};